import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MultiRepCardLease from "../../MultiRepCardLease.js";
import MustRefer from "../../MustRefer.js";
import ClauseCard from "../../ClauseCard.js";
import clauseData from "../../../data/Ontario/clauseData.js";
import clauseCardDesc from "../../../data/Ontario/clauseCardDescription.js";
import importantNotes from "../../../data/Ontario/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";
import ONClauseGenerator from "../../ONClauseGenerator.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export default function LeaseTenantListed() {
  const [TenantDocs, setTenantDocs] = useState([
    "RECO Info Guide Acknowledgement",
    "Tenant Representation Agreement with Schedule A (372)",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Agreement to Lease (400)",
    "Schedule B1 (if eXp holding deposit)",
    "Confirmation of Co-operation (324)",
    "Copy of Deposit & Receipt",
    "Full REALTOR® LEASED MLS Printout",
  ]);

  const [LandlordRep, setLandlordRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [ListingType, setListingType] = useState("MLS");
  const [TenantRep, setTenantRep] = useState("Client");

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const addDisclosure = (e) => {
    setIsDisclosure("Yes");
    if (
      DealDocs.includes("Registrant's Disclosure of Interest (160 or 161)") ===
      true
    ) {
      return;
    } else {
      setDealDocs([
        ...DealDocs,
        "Registrant's Disclosure of Interest (160 or 161)",
      ]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure("No");
    setDealDocs(
      DealDocs.filter(
        (item) => item !== "Registrant's Disclosure of Interest (160 or 161)",
      ),
    );
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    setDealDocs(
      DealDocs.filter((item) => item !== "Full REALTOR® LEASED MLS Printout"),
    );
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    if (DealDocs.includes("Full REALTOR® LEASED MLS Printout") === true) {
      return;
    } else {
      setDealDocs([...DealDocs, "Full REALTOR® LEASED MLS Printout"]);
    }
  };

  const handleLandlordRep = (e) => {
    setLandlordRep(e.target.value);
    if (e.target.value === "Yes") {
      setListingType("MLS");
      if (DealDocs.includes("Full REALTOR® LEASED MLS Printout") === true) {
        return;
      } else {
        setDealDocs([...DealDocs, "Full REALTOR® LEASED MLS Printout"]);
      }
    }
    if (e.target.value === "No") {
      setTenantRep("Client");
      setTenantDocs([
        "RECO Info Guide Acknowledgement",
        "Tenant Representation Agreement with Schedule A (372)",
      ]);
    }
  };

  const handleTenantRep = (e) => {
    setTenantRep(e.target.value);
    if (e.target.value === "Client") {
      setTenantDocs([
        "RECO Info Guide Acknowledgement",
        "Tenant Representation Agreement with Schedule A (372)",
      ]);
    } else {
      setTenantDocs([
        "RECO Info Guide Acknowledgement",
        "RECO Self-Represented Disclosure Form",
      ]);
    }
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 ">
            Do you also represent the Landlord in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleLandlordRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleLandlordRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {LandlordRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">Tenant's Representation Choice?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="Client"
                    value={TenantRep}
                  >
                    <FormControlLabel
                      value="Client"
                      control={<Radio size="small" onClick={handleTenantRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="SRP"
                      control={<Radio size="small" onClick={handleTenantRep} />}
                      label="Self-Represented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
                value={ListingType}
              >
                <div>
                  <FormControlLabel
                    value="MLS"
                    control={<Radio size="small" onClick={setMLS} />}
                    label="MLS"
                  />
                  <FormControlLabel
                    value="Exclusive"
                    control={<Radio size="small" onClick={setExclusive} />}
                    label="Exclusive"
                  />
                </div>

                {LandlordRep !== "Yes" ? (
                  <div>
                    <FormControlLabel
                      value="Mere Posting"
                      control={<Radio size="small" onClick={setMLS} />}
                      label="Mere Posting"
                    />
                    <FormControlLabel
                      value="FRBO"
                      control={<Radio size="small" onClick={setExclusive} />}
                      label="For Rent By Owner"
                    />
                  </div>
                ) : (
                  ""
                )}
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-5">
            Are you or close relatives leasing this property?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={addDisclosure} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={removeDisclosure} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>
        {ListingType === "Mere Posting" ? (
          <>
            <div className="paragraph">
              <p>
                <strong>IMPORTANT:</strong> Even though the listing brokerage is
                providing less services, they still have a representation
                agreement with the Landlord. For the deposit, eXp should hold as
                the listing brokerage typically will not.
                <br />
                <br />
                <strong>FORM 324: </strong>Please ensure commission is clearly
                defined on FORM 324. In the commission section of FORM 324,
                check 4b-2 and put{" "}
                <em>
                  "[the commission amount] as per the remuneration clause in the
                  agreement"
                </em>
                . Make sure you include a Remuneration Clause in the Agreement
                to Lease to cover the agreed upon commission. It is common for
                the listing brokerage to decline signing this form. Be sure to
                have the other parties sign.
                <br />
                <br />
                <strong>
                  Remuneration Clause:
                  <br />
                </strong>
                The landlord and tenant agree that there shall be a credit on
                the closing date as stated in this agreement to lease in favour
                of the the tenant for the amount of ___ (% of the Lease Price or
                specific amount) plus HST, in order to satisfy the tenant’s
                obligation to pay the tenant’s Brokerage in accordance with the
                Tenant Representation Agreement. The Landlord will pay or
                irrevocably directs the deposit holder with sufficient funds to
                pay eXp Realty, Brokerage said commission plus applicable taxes
                immediately upon the completion of the transaction.
              </p>
            </div>
          </>
        ) : (
          ""
        )}
        {ListingType === "FRBO" ? (
          <>
            <div className="paragraph">
              <p>
                <strong>IMPORTANT:</strong> Since the Landlord is a
                Self-Represented Party (SRP), commission cannot be paid by the
                Landlord unless you insert a Remuneration Clause in the
                Agreement to Lease. For the deposit, eXp should hold since there
                isn't another brokerage involved in the transaction.
                <br />
                <br />
                <strong>FORM 324: </strong>For this scenario, you will use
                checkbox #3b only (if using Remuneration Clause). The presence
                of the Remuneration Clause in the agreement allows the
                commission to flow from the Landlord to the Tenant, by way of a
                credit on closing.
                <strong>
                  <br /> <br />
                  Remuneration Clause:
                  <br />
                </strong>
                The landlord and tenant agree that there shall be a credit on
                the closing date as stated in this agreement to lease in favour
                of the the tenant for the amount of ___ (% of the Lease Price or
                specific amount) plus HST, in order to satisfy the tenant’s
                obligation to pay the tenant’s Brokerage in accordance with the
                Tenant Representation Agreement. The Landlord will pay or
                irrevocably directs the deposit holder with sufficient funds to
                pay eXp Realty, Brokerage said commission plus applicable taxes
                immediately upon the completion of the transaction.
                <br /> <br />
              </p>
            </div>
          </>
        ) : (
          ""
        )}
      </div>

      {ListingType === "MLS" || ListingType === "Exclusive" ? (
        <div className="flex flex-col w-full pl-2">
          <div className="clause-notice-green">
            <div className="clause-notice-green-icon">
              <FontAwesomeIcon icon={faCircleInfo} size="lg" />
            </div>
            <div>
              For lease transactions, it is common practice to complete a Form
              410 (Rental Application) before submitting an offer.{" "}
              {LandlordRep === "No"
                ? "Confirm the preferred process with the listing agent."
                : ""}
            </div>
          </div>
        </div>
      ) : null}

      {LandlordRep === "No" && ListingType !== "FRBO" ? (
        <ChecklistCard
          province={"ON"}
          CheckListData={TenantDocs}
          CheckListData2={DealDocs}
          Header="Lease: Tenant Client"
          Header2=" (Listed Property)"
          Title1="Tenant Representation Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}

      {LandlordRep === "No" && ListingType === "FRBO" ? (
        <ChecklistCard
          province={"ON"}
          CheckListData={TenantDocs}
          CheckListData2={[
            "RECO Info Guide Acknowledgement",
            "RECO Self-Represented Party Disclosure Form",
          ]}
          CheckListData3={DealDocs}
          Header="Lease: Tenant Client"
          Header2=" (Landlord is a SRP)"
          Title1="Tenant Representation Documents"
          Title2="Landlord Documents"
          Title3="Deal Documents"
        />
      ) : (
        ""
      )}

      {LandlordRep === "Yes" && TenantRep === "Client" ? (
        <>
          {IsDisclosure === "Yes" ? <MustRefer IsMLS={ListingType} /> : ""}
          {IsDisclosure === "No" ? (
            <>
              <MultiRepCardLease />
              <ChecklistCard
                province={"ON"}
                CheckListData={TenantDocs}
                CheckListData2={DealDocs}
                Header="Lease: Tenant Client"
                Header2=" (Listed Property)"
                Title1="Tenant Representation Documents"
                Title2="Deal Documents"
              />
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {TenantRep === "SRP" ? (
        <ChecklistCard
          province={"ON"}
          CheckListData={TenantDocs}
          CheckListData2={DealDocs}
          Header="Lease: Landlord Client"
          Header2=" (Tenant is a SRP)"
          Title1="Tenant Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}

      {LandlordRep === "Yes" &&
      TenantRep === "Yes" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : (
        <>
          {ListingType === "FRBO" || ListingType === "Mere Posting" ? (
            <ClauseCard
              ClauseCardDescription={clauseCardDesc.filter(
                (item) => item.category.includes("lease") === true,
              )}
              ClauseDataCommon={clauseData.filter(
                (item) =>
                  (item.category.includes("lease") ||
                    item.category.includes("leaseRemuneration")) === true &&
                  item.isCommon === "yes",
              )}
              ClauseDataSituational={clauseData.filter(
                (item) =>
                  item.category.includes("lease") === true &&
                  item.isCommon === "no",
              )}
            />
          ) : (
            <ClauseCard
              ClauseCardDescription={clauseCardDesc.filter(
                (item) => item.category.includes("lease") === true,
              )}
              ClauseDataCommon={clauseData.filter(
                (item) =>
                  item.category.includes("lease") === true &&
                  item.isCommon === "yes",
              )}
              ClauseDataSituational={clauseData.filter(
                (item) =>
                  item.category.includes("lease") === true &&
                  item.isCommon === "no",
              )}
            />
          )}
        </>
      )}
      <ONClauseGenerator
        ListingType={ListingType}
        theme={theme}
        protectiveToneOptions={[
          "Balanced",
          "Landlord Protective",
          "Tenant Protective",
        ]}
      />

      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true,
            )}
          />
        ) : (
          ""
        )}
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("lease") === true,
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
